import * as React from 'react';
import { saveAllDataAction, updateComponentsCounter } from '@company/features/action.company';
import { ISaveHoc } from './IHOC';

export default function saveHOC<OriginalProps>(
  WrappedComponent: React.ComponentClass<OriginalProps>,
  nameInStore: string): React.ComponentClass<OriginalProps & ISaveHoc> {

  return class SaveHOCWrapper extends React.Component<OriginalProps & ISaveHoc, {}> {
    private wrappedRef: HTMLInputElement | any;

    componentDidMount() {
      this.props.dispatch(updateComponentsCounter(1));
    }

    componentWillUnmount() {
      this.props.dispatch(updateComponentsCounter(-1));
    }

    UNSAFE_componentWillReceiveProps(nextProps:OriginalProps & ISaveHoc) {
      if (nextProps.isSaving) {
        this.props.dispatch(saveAllDataAction(this.wrappedRef.state.data, nameInStore));
      }
    }

    render() {
      return <WrappedComponent ref={(wrappedRef) => {this.wrappedRef = wrappedRef;}} {...this.props} />;
    }
  };
}
